module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "page-bar"
  }, [_c('breadcrumb', {
    attrs: {
      "crumbs": _vm.breadcrumbArray
    }
  })], 1), _vm._v(" "), _c('h1', {
    staticClass: "page-title"
  }, [_vm._v("Users")]), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), (_vm.users.length) ? _c('div', {
    staticClass: "margin-top-20"
  }, [_c('div', {
    staticClass: "portlet box blue-hoki"
  }, [_c('div', {
    staticClass: "portlet-title",
    on: {
      "click": function($event) {
        _vm.toggleSearchPanel()
      }
    }
  }, [_vm._m(1, false, false), _vm._v(" "), _c('div', {
    staticClass: "tools"
  }, [_c('a', {
    class: {
      'expand': !_vm.searchCollapse, 'collapse': _vm.searchCollapse
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "portlet-body",
    class: {
      'display-hide': _vm.searchCollapse
    }
  }, [_c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "form-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.searchError.length) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-close": "alert"
    },
    on: {
      "click": function($event) {
        _vm.clearSearchError()
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.searchError))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.first_name),
      expression: "search.first_name"
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.search.first_name.length
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search.first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "first_name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "search_options_search"
    }
  }, [_vm._v("First name")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.last_name),
      expression: "search.last_name"
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.search.last_name.length
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search.last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "last_name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "search_options_search"
    }
  }, [_vm._v("Last name")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.email),
      expression: "search.email"
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.search.email.length
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "search_options_search"
    }
  }, [_vm._v("Email")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.phone),
      expression: "search.phone"
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.search.phone.length
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "phone", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "search_options_search"
    }
  }, [_vm._v("Phone")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-actions right margin-top-20"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.resetSearch()
      }
    }
  }, [_vm._v(" Reset Search")]), _vm._v(" "), _c('button', {
    staticClass: "btn blue",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.searchUsers($event)
      }
    }
  }, [_vm._v("Search")])])])])])]) : _vm._e(), _vm._v(" "), _c('loading-screen', {
    attrs: {
      "show": _vm.displayUserData,
      "color": '#2C3E50',
      "display": 'inline'
    }
  }), _vm._v(" "), (_vm.users.length && !_vm.searchResults.length) ? _c('div', {
    staticClass: "margin-top-20"
  }, [_c('div', {
    staticClass: "relative-block"
  }, [_c('div', {
    staticClass: "clearfix margin-bottom-10"
  }, [_c('el-dropdown', {
    attrs: {
      "trigger": "click",
      "size": "mini",
      "show-timeout": 50,
      "hide-timeout": 50
    },
    on: {
      "command": _vm.updateSortByOrder
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tSort by\n\t\t\t\t\t\t\t"), _c('span', [(_vm.sortBy.order === 'ASC') ? _c('i', {
    staticClass: "fa fa-sort-alpha-asc"
  }) : _vm._e(), _vm._v(" "), (_vm.sortBy.order === 'DESC') ? _c('i', {
    staticClass: "fa fa-sort-alpha-desc"
  }) : _vm._e()]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": "ASC"
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-alpha-asc"
  })]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "DESC"
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-alpha-desc"
  })])], 1)], 1), _vm._v(" "), _c('page-results', {
    staticClass: "pull-right",
    attrs: {
      "totalResults": _vm.totalResults,
      "activePage": _vm.activePage
    },
    on: {
      "pageResults": _vm.resultsPerPageUpdate
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "margin-top-30 search-content-4"
  }, [_c('div', {
    staticClass: "search-table table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-condensed table-hover"
  }, [_vm._m(2, false, false), _vm._v(" "), _c('tbody', _vm._l((_vm.users), function(user) {
    return _c('tr', {
      staticClass: "clickable",
      on: {
        "click": function($event) {
          _vm.openUserProfile(user)
        }
      }
    }, [_c('td', {
      staticClass: "profile-image-table-row"
    }, [_c('div', {
      staticClass: "missing-profile-image"
    }, [(user.first_name || user.last_name) ? _c('span', [_vm._v(_vm._s(user.first_name.toUpperCase().substring(0, 1)) + _vm._s(user.last_name.toUpperCase().substring(0, 1)))]) : _c('span', [_vm._v(_vm._s(user.email.toUpperCase().substring(0, 1)))])])]), _vm._v(" "), _c('td', [(user.first_name.length && user.last_name.length) ? _c('h3', [_vm._v(_vm._s(user.first_name) + " " + _vm._s(user.last_name))]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(user.email) + " ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm.formatPhone(user.phone)) + " ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(user.city) + " ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(user.province) + " ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(user.total_orders) + " ")]), _vm._v(" "), _c('td', [_vm._v(" $" + _vm._s(user.total_spent) + " ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(user.created_at.substring(0, 10)) + " ")])])
  }))])]), _vm._v(" "), (_vm.users.length && _vm.numPages > 1) ? _c('div', {
    staticClass: "clearfix"
  }, [_c('pagination', {
    attrs: {
      "passedPage": _vm.activePage,
      "numPages": _vm.numPages
    },
    on: {
      "activePageChange": _vm.activePageUpdate
    }
  })], 1) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.users.length && _vm.searchResults.length) ? _c('div', {
    staticClass: "margin-top-20"
  }, [_c('div', {
    staticClass: "relative-block"
  }, [(_vm.users.length) ? _c('div', {
    staticClass: "clearfix margin-bottom-10"
  }, [_c('el-dropdown', {
    attrs: {
      "trigger": "click",
      "size": "mini",
      "show-timeout": 50,
      "hide-timeout": 50
    },
    on: {
      "command": _vm.updateSortByOrder
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tSort by\n\t\t\t\t\t\t\t"), _c('span', [(_vm.sortBy.order === 'ASC') ? _c('i', {
    staticClass: "fa fa-sort-alpha-asc"
  }) : _vm._e(), _vm._v(" "), (_vm.sortBy.order === 'DESC') ? _c('i', {
    staticClass: "fa fa-sort-alpha-desc"
  }) : _vm._e()]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": "ASC"
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-alpha-asc"
  })]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "DESC"
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-alpha-desc"
  })])], 1)], 1), _vm._v(" "), _c('page-results', {
    staticClass: "pull-right",
    attrs: {
      "totalResults": _vm.totalResults,
      "activePage": _vm.searchActivePage
    },
    on: {
      "pageResults": _vm.resultsPerPageUpdate
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "margin-top-30 search-content-4"
  }, [_c('div', {
    staticClass: "search-table table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-condensed"
  }, [_vm._m(3, false, false), _vm._v(" "), _c('tbody', _vm._l((_vm.searchResults), function(user) {
    return _c('tr', [_c('td', {
      staticClass: "profile-image-table-row"
    }, [_c('div', {
      staticClass: "missing-profile-image"
    }, [(user.first_name || user.last_name) ? _c('span', [_vm._v(_vm._s(user.first_name.toUpperCase().substring(0, 1)) + _vm._s(user.last_name.toUpperCase().substring(0, 1)))]) : _c('span', [_vm._v(_vm._s(user.email.toUpperCase().substring(0, 1)))])])]), _vm._v(" "), _c('td', {
      staticClass: "clickable",
      on: {
        "click": function($event) {
          _vm.openUserProfile(user)
        }
      }
    }, [(user.first_name.length && user.last_name.length) ? _c('h3', [_vm._v(_vm._s(user.first_name) + " " + _vm._s(user.last_name))]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(user.email) + " ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm.formatPhone(user.phone)) + " ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(user.city) + " ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(user.province) + " ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(user.total_orders) + " ")]), _vm._v(" "), _c('td', [_vm._v(" $" + _vm._s(user.total_spent) + " ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(user.created_at.substring(0, 10)) + " ")])])
  }))])]), _vm._v(" "), (_vm.searchResults.length && _vm.searchNumPages > 1) ? _c('div', {
    staticClass: "clearfix"
  }, [_c('pagination', {
    attrs: {
      "passedPage": _vm.searchActivePage,
      "numPages": _vm.searchNumPages
    },
    on: {
      "activePageChange": _vm.activeSearchPageUpdate
    }
  })], 1) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('div', [_c('no-results', {
    attrs: {
      "show": !_vm.users.length && !_vm.displayUserData,
      "type": 'users'
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "note note-info"
  }, [_c('p', [_vm._v("Search and view Application Users.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption"
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v("\n\t\t\t\t\t\tSearch Panel\n\t\t\t\t\t")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-blue-chambray"
  }, [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_c('a', {
    staticClass: "no-click"
  }, [_vm._v("Name")])]), _vm._v(" "), _c('th', [_c('a', {
    staticClass: "no-click"
  }, [_vm._v("Email")])]), _vm._v(" "), _c('th', [_c('a', {
    staticClass: "no-click"
  }, [_vm._v("Phone")])]), _vm._v(" "), _c('th', [_c('a', {
    staticClass: "no-click"
  }, [_vm._v("City")])]), _vm._v(" "), _c('th', [_c('a', {
    staticClass: "no-click"
  }, [_vm._v("Province")])]), _vm._v(" "), _c('th', [_c('a', {
    staticClass: "no-click"
  }, [_vm._v("Total orders")])]), _vm._v(" "), _c('th', [_c('a', {
    staticClass: "no-click"
  }, [_vm._v("Total spent")])]), _vm._v(" "), _c('th', [_c('a', {
    staticClass: "no-click"
  }, [_vm._v("Sign Up Date")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-blue-chambray"
  }, [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_c('a', {
    staticClass: "no-click"
  }, [_vm._v("Name")])]), _vm._v(" "), _c('th', [_c('a', {
    staticClass: "no-click"
  }, [_vm._v("Email")])]), _vm._v(" "), _c('th', [_c('a', {
    staticClass: "no-click"
  }, [_vm._v("Phone")])]), _vm._v(" "), _c('th', [_c('a', {
    staticClass: "no-click"
  }, [_vm._v("City")])]), _vm._v(" "), _c('th', [_c('a', {
    staticClass: "no-click"
  }, [_vm._v("Province")])]), _vm._v(" "), _c('th', [_c('a', {
    staticClass: "no-click"
  }, [_vm._v("Total orders")])]), _vm._v(" "), _c('th', [_c('a', {
    staticClass: "no-click"
  }, [_vm._v("Total spent")])]), _vm._v(" "), _c('th', [_c('a', {
    staticClass: "no-click"
  }, [_vm._v("Sign Up Date")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eb60cf94"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/UserManager/UserList.vue
// module id = 790
// module chunks = 0